exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".empty-Page {\n  display: block;\n  position: relative;\n  height: 200px;\n  width: auto;\n  -ms-flex-item-align: center;\n  align-self: center;\n  justify-self: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/CarEditorPage/components/Empty/styles.scss
// module id = 1649
// module chunks = 0